import { connect } from 'react-redux';
import View from './HealthCareChartView';
import MobileView from './MobileHealthCareChartView';
import * as healthCareSelector from './HealthCareChartSelector';
import { getGoalsChartList } from './HealthCareChartActions';

const mapStateToProps = (state, props) => ({
  chartData: healthCareSelector.goalChartPopulated(state, props),
  chartTitle: healthCareSelector.chartTitle(state, props),
  dataIsOutdated: healthCareSelector.dataIsOutdated(state, props),
  fpId: healthCareSelector.fpId(state, props),
  goalId: healthCareSelector.goalId(state, props),
  hasLoaded: healthCareSelector.hasLoaded(state, props),
  isPdf: healthCareSelector.isPdf(state, props),
  isPrint: healthCareSelector.isPrint(state, props),
});

const mapDispatchToProps = dispatch => ({
  getChartData: (fpId, clientId, isPdf, goalId) => (
    dispatch(getGoalsChartList(fpId, clientId, isPdf, goalId))
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileHealthCareChart = connect(mapStateToProps, mapDispatchToProps)(MobileView);
